import { render, staticRenderFns } from "./ot-profile-details.vue?vue&type=template&id=34f80622&scoped=true&"
import script from "./ot-profile-details.vue?vue&type=script&lang=ts&"
export * from "./ot-profile-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-profile-details.vue?vue&type=style&index=0&id=34f80622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f80622",
  null
  
)

export default component.exports